/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BranchCapacitiesDto,
  CreateProductCommand,
  ErrorResponse,
  GenericLinkPlateformesCommand,
  GetBrokerProductsResponse,
  GetFacetsResponse,
  GetGenericListCommandDto,
  GetPlateformeListResponse,
  GetProductListResponse,
  GetProducts404Response,
  GetProduitAdminListResponse,
  OperationResponse,
  ProductDto,
  UpdateProductCommand,
} from '../models/index';
import {
    BranchCapacitiesDtoFromJSON,
    BranchCapacitiesDtoToJSON,
    CreateProductCommandFromJSON,
    CreateProductCommandToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GenericLinkPlateformesCommandFromJSON,
    GenericLinkPlateformesCommandToJSON,
    GetBrokerProductsResponseFromJSON,
    GetBrokerProductsResponseToJSON,
    GetFacetsResponseFromJSON,
    GetFacetsResponseToJSON,
    GetGenericListCommandDtoFromJSON,
    GetGenericListCommandDtoToJSON,
    GetPlateformeListResponseFromJSON,
    GetPlateformeListResponseToJSON,
    GetProductListResponseFromJSON,
    GetProductListResponseToJSON,
    GetProducts404ResponseFromJSON,
    GetProducts404ResponseToJSON,
    GetProduitAdminListResponseFromJSON,
    GetProduitAdminListResponseToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    ProductDtoFromJSON,
    ProductDtoToJSON,
    UpdateProductCommandFromJSON,
    UpdateProductCommandToJSON,
} from '../models/index';

export interface CreateProductRequest {
    createProductCommand: CreateProductCommand;
}

export interface GetAdminProduitListFacetsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetAdminProduitsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetPlateformesRequest {
    productId: string;
}

export interface GetProductByIDRequest {
    productId: string;
}

export interface GetProductsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface LinkPlateformesRequest {
    productId: string;
    genericLinkPlateformesCommand: GenericLinkPlateformesCommand;
}

export interface UpdateProductRequest {
    productId: string;
    updateProductCommand: UpdateProductCommand;
}

/**
 * 
 */
export class ProductsApi extends runtime.BaseAPI {

    /**
     * Create product
     */
    async createProductRaw(requestParameters: CreateProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createProductCommand'] == null) {
            throw new runtime.RequiredError(
                'createProductCommand',
                'Required parameter "createProductCommand" was null or undefined when calling createProduct().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/produits`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateProductCommandToJSON(requestParameters['createProductCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create product
     */
    async createProduct(requestParameters: CreateProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createProductRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Facettes (branches, owners, plateformes, active). Permission BackOffice.AdminProduits.Read. 
     * Facettes de la liste admin des produits (BO admin)
     */
    async getAdminProduitListFacetsRaw(requestParameters: GetAdminProduitListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacetsResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getAdminProduitListFacets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/produits/admin/liste/filtres`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacetsResponseFromJSON(jsonValue));
    }

    /**
     * Facettes (branches, owners, plateformes, active). Permission BackOffice.AdminProduits.Read. 
     * Facettes de la liste admin des produits (BO admin)
     */
    async getAdminProduitListFacets(requestParameters: GetAdminProduitListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacetsResponse> {
        const response = await this.getAdminProduitListFacetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liste admin paginée des produits avec facettes/tri. Permission BackOffice.AdminProduits.Read. filters : branchIds, owners, plateformeIds, active, period. 
     * Lister les produits (BO admin)
     */
    async getAdminProduitsRaw(requestParameters: GetAdminProduitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetProduitAdminListResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getAdminProduits().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/produits/admin/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetProduitAdminListResponseFromJSON(jsonValue));
    }

    /**
     * Liste admin paginée des produits avec facettes/tri. Permission BackOffice.AdminProduits.Read. filters : branchIds, owners, plateformeIds, active, period. 
     * Lister les produits (BO admin)
     */
    async getAdminProduits(requestParameters: GetAdminProduitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetProduitAdminListResponse> {
        const response = await this.getAdminProduitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Capabilities of every branch of the registry that the product form depends on (e.g. targeted subscriber).
     * Get branch capabilities
     */
    async getBranchesCapacitesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BranchCapacitiesDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/produits/branches-capacites`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BranchCapacitiesDtoFromJSON));
    }

    /**
     * Capabilities of every branch of the registry that the product form depends on (e.g. targeted subscriber).
     * Get branch capabilities
     */
    async getBranchesCapacites(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BranchCapacitiesDto>> {
        const response = await this.getBranchesCapacitesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns the list of products the connected broker has access to, with coverages, owner info and theme.
     * Get broker products
     */
    async getBrokerProductsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBrokerProductsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/produits/courtier`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBrokerProductsResponseFromJSON(jsonValue));
    }

    /**
     * Returns the list of products the connected broker has access to, with coverages, owner info and theme.
     * Get broker products
     */
    async getBrokerProducts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBrokerProductsResponse> {
        const response = await this.getBrokerProductsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get product by ID
     */
    async getPlateformesRaw(requestParameters: GetPlateformesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPlateformeListResponse>> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling getPlateformes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/produits/{productId}/plateformes`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPlateformeListResponseFromJSON(jsonValue));
    }

    /**
     * Get product by ID
     */
    async getPlateformes(requestParameters: GetPlateformesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPlateformeListResponse> {
        const response = await this.getPlateformesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get product by ID
     */
    async getProductByIDRaw(requestParameters: GetProductByIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductDto>> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling getProductByID().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/produits/{productId}`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductDtoFromJSON(jsonValue));
    }

    /**
     * Get product by ID
     */
    async getProductByID(requestParameters: GetProductByIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductDto> {
        const response = await this.getProductByIDRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get products
     */
    async getProductsRaw(requestParameters: GetProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetProductListResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getProducts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/produits/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetProductListResponseFromJSON(jsonValue));
    }

    /**
     * Get products
     */
    async getProducts(requestParameters: GetProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetProductListResponse> {
        const response = await this.getProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link plateformes to product
     */
    async linkPlateformesRaw(requestParameters: LinkPlateformesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling linkPlateformes().'
            );
        }

        if (requestParameters['genericLinkPlateformesCommand'] == null) {
            throw new runtime.RequiredError(
                'genericLinkPlateformesCommand',
                'Required parameter "genericLinkPlateformesCommand" was null or undefined when calling linkPlateformes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/produits/{productId}`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: GenericLinkPlateformesCommandToJSON(requestParameters['genericLinkPlateformesCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Link plateformes to product
     */
    async linkPlateformes(requestParameters: LinkPlateformesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.linkPlateformesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update product
     */
    async updateProductRaw(requestParameters: UpdateProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling updateProduct().'
            );
        }

        if (requestParameters['updateProductCommand'] == null) {
            throw new runtime.RequiredError(
                'updateProductCommand',
                'Required parameter "updateProductCommand" was null or undefined when calling updateProduct().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/produits/{productId}`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProductCommandToJSON(requestParameters['updateProductCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Update product
     */
    async updateProduct(requestParameters: UpdateProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateProductRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
